import * as DateFilter from './dateFilter'
import * as TimeStampFilter from './timeStampFilter'
import * as TimeStampFNowFilter from './timeStampFromNowFilter'
import * as CpfCnpjFilter from './cpfCnpjFilter'
import * as FoneFilter from './foneFilter'
import * as CurrencyFilter from './currencyFilter'
import * as PercentFilter from './percentFilter'
import * as MonthNameFilter from './monthNameFilter'
import * as DecimalFilter from './decimalFilter'
import * as MeterFilter from './meterFilter'

export default {
  DateFilter,
  TimeStampFilter,
  TimeStampFNowFilter,
  CpfCnpjFilter,
  FoneFilter,
  CurrencyFilter,
  PercentFilter,
  MonthNameFilter,
  DecimalFilter,
  MeterFilter
}
